import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-nodata",
  "use": "icon-nodata-usage",
  "viewBox": "0 0 180 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 180 165\" id=\"icon-nodata\"><path d=\"M156.544 66.21c-3.352-6.21 0 0 0 0S180 102.04 180 108.25v43.472c0 7.166-5.745 12.421-12.446 12.421H12.446C5.745 164.143 0 158.41 0 151.722V108.25c0-6.689 21.064-38.696 23.458-42.517C25.85 61.91 28.724 60 33.032 60h113.937c7.18 0 11.488 9.553 9.575 6.21zM89 0a5 5 0 0 1 5 5v25.925a5 5 0 1 1-10 0V5a5 5 0 0 1 5-5zm59.701 7.261a5 5 0 0 1 0 7.071L130.37 32.664a5 5 0 0 1-7.071-7.071L141.63 7.26a5 5 0 0 1 7.071 0zm-118.64.275a5 5 0 0 1 7.072 0l18.331 18.331a5 5 0 1 1-7.07 7.071L30.061 14.607a5 5 0 0 1 0-7.071zm85.79 97.704h53.097l-18.193-31.963c-2.872-4.3-3.351-5.733-7.182-5.733H38.34c-4.788 0-8.139 5.733-8.139 5.733L12.009 105.24h52.14s4.308 0 5.745 3.822v1.432c0 10.989 9.095 20.065 20.107 20.065 11.01 0 20.106-9.076 20.106-20.065v-.954c.478-2.867 2.872-4.3 5.744-4.3z\" fill=\"#EDEDED\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/nodata.svg
// module id = KCuv
// module chunks = 28